import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/layouts/admin.vue").then(m => m.default || m))
}